import { MetaHeroGrid } from '../MetaHeroGrid';
import { FullScreenImageBackground } from '../FullScreenImageBackground';
import { heroConfig } from './HeroContent.config';
import styles from './HeroContent.module.css';

interface HeroContentProps {
  isHeadlineLink: boolean;
  linkToFreshSignup: string;
  isAccessibilityThemeOn: boolean;
}

export const HeroContent = ({
  isHeadlineLink,
  linkToFreshSignup,
  isAccessibilityThemeOn,
}: HeroContentProps) => {
  return (
    <MetaHeroGrid
      isTextOnBottom
      withRightOverlay
      isHeadlineLink={isHeadlineLink}
      linkToFreshSignup={linkToFreshSignup}
      isAccessibilityThemeOn={isAccessibilityThemeOn}
      headlineText={heroConfig.title}
      subtitle={heroConfig.subtitle}
      ctaString={heroConfig.cta}
      desktopColumnWidth={8}
      gridItemClassname={styles.cta}
      titleClassname={styles.title}
      subtitleClassname={styles.subtitle}
      buttonClassname={styles.button}
      containerClassname={styles.container}
    >
      <FullScreenImageBackground
        moveBackgroundLower={heroConfig.lowerBackground}
        sources={heroConfig.assets}
        alt={heroConfig.alt}
      />
    </MetaHeroGrid>
  );
};
